import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useCitiesSelect from 'modules/cities/hooks/use-cities-select';
import {translatedCreateNeighborhoodProps} from 'modules/neighborhoods/hooks/use-create-neighborhood';
import useEditNeighborhood, {
  EditNeighborhoodProps,
} from 'modules/neighborhoods/hooks/use-edit-neighborhood';
import neighborhoodsKeys from 'modules/neighborhoods/util/neighborhoods-keys';

import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

interface Props {
  cityId?: string;
}

const EditNeighborhood: React.FC<Props> = ({cityId}) => {
  const params = useParams();
  const id = params.neighborhoodId ?? params.id;
  const {getInput, getSwitch, getSelect, getPriceInput} =
    useFormInputs<EditNeighborhoodProps>();
  const accessControls = useAccessControls();

  const {data, isLoading} = useCitiesSelect();

  return (
    <Edition<EditNeighborhoodProps>
      {...{titleBar: !cityId ? {title: 'Cadastrar bairro'} : undefined}}
      inputs={[
        getInput({
          name: 'name',
        }),
        getSelect({
          name: 'cityId',
          data,
          isLoading,
          hidden: () => !!cityId || !!accessControls.cityId,
        }),
        getPriceInput({name: 'deliveryPrice'}),
        getPriceInput({name: 'deliveryManFee'}),
        getSwitch({
          name: 'active',
        }),
      ]}
      translationKey={translatedCreateNeighborhoodProps}
      detailsUrl={`/neighborhoods/${id}`}
      onSubmit={() => useEditNeighborhood(id!, !!cityId)}
      queryKey={neighborhoodsKeys.details(id!)}
    />
  );
};

export default EditNeighborhood;
